// @flow

import React from 'react';
import { borderWidth } from 'polished';
import RewriteLink from 'app/components/routing/RewriteLink';
import Tappable from 'app/components/commons/Tappable';
import classNames from 'classnames';
import colorUtils from 'color';
import { useGlamor } from 'app/glamor';

type Props = {
  children?: any,
  className?: string,
  classes: Object,
  link?: string,
  onTap?: () => void,
  style?: Object,
};

const defaultProps = {
  children: undefined,
  className: undefined,
  link: undefined,
  onTap: undefined,
  style: undefined,
};

function Row({
  children,
  classes,
  className,
  link,
  onTap,
  style,
}: Props) {
  return (
    <Tappable
      component={link ? RewriteLink : 'div'}
      to={link}
      onTap={onTap}
      className={classNames(classes.row, className)}
      style={style}
    >
      {children}
    </Tappable>
  );
}

Row.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    row: {
      backgroundColor: theme.color.white,
      borderColor: theme.color.basis6,
      borderStyle: 'solid',
      // $FlowIgnore
      ...borderWidth('0', '0', 1),
      color: theme.color.basis1,
      display: 'block',
      fontSize: theme.fontSize.default,
      transition: 'background-color 0.2s',
      '&.Tappable-active': {
        backgroundColor: colorUtils(theme.color.white).darken(0.05).hex(),
        textDecoration: 'none',
      },
    },
  };
}

export default useGlamor(applyStyles)(Row);
